import { render } from "./TakePhoto.vue?vue&type=template&id=04d0e1e3&scoped=true"
import script from "./TakePhoto.vue?vue&type=script&lang=js"
export * from "./TakePhoto.vue?vue&type=script&lang=js"

import "./TakePhoto.vue?vue&type=style&index=0&id=04d0e1e3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d0e1e3"]])

export default __exports__